var render, staticRenderFns
import script from "./LinkHandler.vue?vue&type=script&lang=ts"
export * from "./LinkHandler.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../src-custom-solutions/embeds/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports